import React, {Component} from 'react';
import {Card} from 'antd';

import MembershipDetail from './components/MembershipDetail';
import QueryAndMutationForMembership, {QueryAndMutationForMembershipObject} from './components/QueryMutation';

import './styles.css';
import {RouteComponentProps, withRouter} from 'react-router';

interface Properties extends RouteComponentProps {
  regionId: string;
  clubId: string;
  membershipExternalId: string;
}

class MembershipDetailWrap extends Component<Properties> {
  render() {
    return (
      <QueryAndMutationForMembership {...this.props}>
        {({membershipData, memberships, clubLanguages, updateMembership}: QueryAndMutationForMembershipObject) => {
          const {membership, club, region} = membershipData;
          const {languages} = clubLanguages;
          const error = membershipData.error || clubLanguages.error;
          const loading = membershipData.loading || clubLanguages.loading || memberships.loading;
          if (loading) {
            return <Card loading={loading} />;
          }

          if (error) {
            return `Error! ${error.message}`;
          }

          const membershipPrice: any =
            memberships &&
            memberships.memberships &&
            memberships.memberships.find(m => m.membershipExternalId === membership.membershipExternalId);

          const defaultMembership: any = memberships && memberships.memberships && memberships.memberships.find(m => Boolean(m.isDefault));
          const isDefaultMembershipExist: any = Boolean(defaultMembership) && defaultMembership.id !== membership.id;
          const isDefaultSelected = Boolean(defaultMembership) && isDefaultMembershipExist;
          if (!membership) {
            this.props.history.push('/error');
            return <div />;
          }

          return (
            <MembershipDetail
              isDefaultSelected={isDefaultSelected}
              membership={membership}
              price={membershipPrice}
              club={club}
              region={region}
              languages={languages}
              updateMembership={updateMembership}
            />
          );
        }}
      </QueryAndMutationForMembership>
    );
  }
}

export default withRouter(MembershipDetailWrap);



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipDetail/MembershipDetailWrap.tsx